export default __webpack_public_path__ + "709d60e09e4100049c469b7911ec8edd.png";